import React from 'react'
import './style.scss'
import { Icon } from 'react-icons-kit'
import { Modal } from 'react-bootstrap'
import { eye, x } from 'react-icons-kit/feather'

const ContactViewConfirm = (props) => {
    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            dialogClassName="custom-settings-modal sp-modal"
            backdrop="static"
            keyboard={false}
            centered
        >
            <div className="sp-modal-head">
                <span className="sp-modal-icon"><Icon icon={eye} size={18} /></span>
                <div className="sp-modal-head-text">
                    <h6>View contact details?</h6>
                    <p>Confirm to continue</p>
                </div>
                <button type="button" className="sp-modal-close" onClick={props.onHide} aria-label="Close">
                    <Icon icon={x} size={18} />
                </button>
            </div>

            <div className="sp-modal-body">
                <p className="sp-modal-lead">
                    Viewing the contact details of this member will use one contact view from your package.
                </p>

                <div className="sp-modal-actions">
                    <button type="button" className="sp-modal-btn sp-modal-btn-ghost" onClick={props.onHide}>
                        Cancel
                    </button>
                    <button type="button" className="sp-modal-btn sp-modal-btn-upgrade" onClick={props.handleViewConfirm}>
                        Confirm view
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default ContactViewConfirm
